import { z } from 'zod';
// Envelope de error uniforme — ver /docs/modules.md y skill web-architecture.
// Toda respuesta de error de la API tiene esta forma.
export const errorEnvelopeSchema = z.object({
    error: z.object({
        code: z.string().regex(/^[A-Z][A-Z0-9_]*$/, 'code debe ser SCREAMING_SNAKE_CASE'),
        message: z.string().min(1),
        details: z.record(z.string(), z.unknown()).optional(),
    }),
});
// Helper para construir errores tipados en backend y consumirlos tipados en frontend.
export function buildError(code, message, details) {
    return { error: details ? { code, message, details } : { code, message } };
}
//# sourceMappingURL=error.js.map